document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  // ---------- Mobile menu open / close ----------
  const openMenuMobile = document.querySelector('.header__gapfy .open_nav_items');
  const closeMenuMobile = document.querySelector('.header__gapfy .close_nav_items');
  const mobileNav = document.querySelector('.header__menu_mobile .nav_items');

  // Contêiner do trap inclui os botões abrir/fechar (irmãos do .nav_items)
  const mobileMenuWrap = mobileNav ? mobileNav.closest('.header__menu_mobile') || mobileNav : null;

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.removeAttribute('open');
    document.body.style.overflow = 'auto';
    if (openMenuMobile) openMenuMobile.setAttribute('aria-expanded', 'false');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(openMenuMobile);
  }

  if (openMenuMobile && mobileNav) {
    openMenuMobile.addEventListener('click', () => {
      mobileNav.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      openMenuMobile.setAttribute('aria-expanded', 'true');
      if (typeof trapFocus === 'function' && mobileMenuWrap) trapFocus(mobileMenuWrap);
    });
  }
  if (closeMenuMobile && mobileNav) {
    closeMenuMobile.addEventListener('click', closeMobileNav);
  }
  // Escape fecha o menu mobile
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav && mobileNav.hasAttribute('open')) closeMobileNav();
  });

  const mainLinks = document.querySelector('.nav_items .main_items');

  function closeDesktopSubmenus() {
    document
      .querySelectorAll('.header__menu_desktop .nav_items [data-submenu]')
      .forEach((s) => s.setAttribute('closed', ''));
    document
      .querySelectorAll('.header__menu_desktop .nav_items [data-menu] > a[aria-expanded]')
      .forEach((a) => a.setAttribute('aria-expanded', 'false'));
  }

  // ---------- Mobile: tap a top-level item to open its submenu ----------
  document.querySelectorAll('.nav_items [data-menu]').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (isDesktop()) return; // desktop uses hover + real navigation

      // On mobile, prevent navigating and open the submenu instead
      const anchor = link.querySelector('a');
      if (anchor && anchor.getAttribute('href')) e.preventDefault();

      const idx = link.dataset.menu;
      const submenuMobile = document.querySelector(
        `.header__menu_mobile .nav_items [data-submenu="${idx}"]`
      );
      const submenuDesktop = document.querySelector(
        `.header__menu_desktop .nav_items [data-submenu="${idx}"]`
      );

      if (submenuMobile) submenuMobile.toggleAttribute('closed');
      if (submenuDesktop) {
        submenuDesktop.toggleAttribute('closed');
        if (mainLinks) mainLinks.toggleAttribute('closed');
      }

      // Close any other open submenus
      document.querySelectorAll('.nav_items [data-submenu]').forEach((s) => {
        if (s !== submenuMobile && s !== submenuDesktop) s.setAttribute('closed', '');
      });
    });
  });

  // ---------- Mobile: "back" buttons inside submenus ----------
  document.querySelectorAll('.nav_items .submenu_back__container').forEach((back) => {
    back.addEventListener('click', () => {
      const submenu = back.closest('[data-submenu]');
      if (submenu) {
        submenu.toggleAttribute('closed');
        if (mainLinks) mainLinks.toggleAttribute('closed');
      }
    });
  });

  // ---------- Desktop: hover opens the mega-menu (delayed close so links stay clickable) ----------
  const desktopMenu = document.querySelector('.header__menu_desktop');
  if (desktopMenu) {
    let closeTimer = null;
    const cancelClose = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };
    const scheduleClose = () => {
      cancelClose();
      closeTimer = setTimeout(() => {
        if (isDesktop()) closeDesktopSubmenus();
      }, 280);
    };

    // Top-level items: hover opens its submenu; leaving starts the delayed close
    desktopMenu.querySelectorAll('.nav_items [data-menu]').forEach((li) => {
      li.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        cancelClose();
        const idx = li.dataset.menu;
        const submenu = document.querySelector(
          `.header__menu_desktop .nav_items [data-submenu="${idx}"]`
        );
        closeDesktopSubmenus();
        if (submenu) {
          submenu.removeAttribute('closed');
          const anchor = li.querySelector('a[aria-expanded]');
          if (anchor) anchor.setAttribute('aria-expanded', 'true');
        }
      });
      li.addEventListener('mouseleave', scheduleClose);
    });

    // The open submenu panel: entering it cancels the close (so you can reach the links);
    // leaving it schedules the close again.
    desktopMenu.querySelectorAll('.nav_items [data-submenu]').forEach((sub) => {
      sub.addEventListener('mouseenter', cancelClose);
      sub.addEventListener('mouseleave', scheduleClose);
    });

    // Teclado: focar um item de topo abre o submenu dele; sair do menu fecha; Escape fecha
    desktopMenu.addEventListener('focusin', (e) => {
      if (!isDesktop()) return;
      const li = e.target.closest('[data-menu]');
      if (li && desktopMenu.contains(li)) {
        cancelClose();
        const idx = li.dataset.menu;
        const submenu = document.querySelector(
          `.header__menu_desktop .nav_items [data-submenu="${idx}"]`
        );
        closeDesktopSubmenus();
        if (submenu) {
          submenu.removeAttribute('closed');
          const anchor = li.querySelector('a[aria-expanded]');
          if (anchor) anchor.setAttribute('aria-expanded', 'true');
        }
      } else if (!e.target.closest('[data-submenu]')) {
        closeDesktopSubmenus();
      }
    });
    desktopMenu.addEventListener('focusout', (e) => {
      if (!isDesktop()) return;
      if (!e.relatedTarget || !desktopMenu.contains(e.relatedTarget)) scheduleClose();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDesktop()) closeDesktopSubmenus();
    });
  }

  // ---------- Search toggle ----------
  const searchIcon = document.querySelector('.header__gapfy .header__search .search__open');
  const searchClose = document.querySelector(
    '.header__gapfy .header__search .search_input__container .search_close'
  );
  const searchInput = document.querySelector(
    '.header__gapfy .header__search .search_input__container'
  );

  if (searchIcon && searchInput) {
    searchIcon.addEventListener('click', () => {
      searchInput.toggleAttribute('open');
      closeDesktopSubmenus();
      searchIcon.setAttribute('aria-expanded', String(searchInput.hasAttribute('open')));
      // Focus the field when opening, for keyboard/UX
      if (searchInput.hasAttribute('open')) {
        const field = searchInput.querySelector('input[type="search"], input[type="text"]');
        if (field) setTimeout(() => field.focus(), 50);
      }
    });
  }
  function closeHeaderSearch() {
    if (!searchInput) return;
    searchInput.removeAttribute('open');
    if (searchIcon) searchIcon.setAttribute('aria-expanded', 'false');
  }
  if (searchClose && searchInput) {
    searchClose.addEventListener('click', closeHeaderSearch);
  }
  // Close search with Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchInput && searchInput.hasAttribute('open')) {
      closeHeaderSearch();
      if (searchIcon) searchIcon.focus();
    }
  });

  // ---------- Hide-on-scroll with hysteresis ----------
  const header = document.querySelector('.header__section');
  if (header) {
    let lastScroll = window.scrollY;
    let ticking = false;
    const HIDE_AFTER = 150; // don't hide until scrolled past this
    const DELTA = 8; // ignore jittery sub-pixel scrolls

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        window.requestAnimationFrame(() => {
          const y = window.scrollY;
          if (Math.abs(y - lastScroll) > DELTA) {
            if (y > lastScroll && y > HIDE_AFTER) {
              header.classList.add('header--hidden');
              closeDesktopSubmenus();
            } else {
              header.classList.remove('header--hidden');
            }
            lastScroll = y;
          }
          ticking = false;
        });
        ticking = true;
      },
      { passive: true }
    );
  }
});
